import * as React from 'react';
import * as ReactDom from 'react-dom';

import Routes from './Routes';
import { BrowserRouter } from 'react-router-dom';

/**
 * Our main entry point, just wraps our routes.
 */
class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx